import React from 'react';
import Link from 'gatsby-link';
import Label from '../label';

const HeaderItem = ({itemConfig, children}) => {
    return (
        <Link to={itemConfig.to} className={`navbar-item`}>
            { itemConfig.name } { children }
            {
                itemConfig.label && <Label type={itemConfig.label.type}> {itemConfig.label.content}</Label>
            }
        </Link>
    )
};


export default HeaderItem;


// WEBPACK FOOTER //
// ./src/components/header/header-item.js